"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsProvider = void 0;
const React = __importStar(require("react"));
const app_settings_context_1 = require("./app-settings-context");
const app_settings_hook_1 = require("./app-settings-hook");
function AppSettingsProvider({ children, url, autoInit = true, }) {
    const { context, settings } = (0, app_settings_hook_1.useAppSettings)(url);
    React.useEffect(() => {
        if (autoInit) {
            context.init();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(app_settings_context_1.AppSettingsContext.Provider, { value: context }, settings !== undefined && children));
}
exports.AppSettingsProvider = AppSettingsProvider;
//# sourceMappingURL=app-settings-provider.js.map